import React from 'react'
import {useSelector} from 'react-redux'
import Cell from './Cell'

const HeaderCell = ({data, editableHeader, handleBlur, handleFocus}) => {
    const collectionState = useSelector(state => state.collection.collectionState)
    const {sorting} = collectionState
    const sort = sorting.find(obj => obj.fieldId === data.name)

    return (
        <Cell
            colId={data.name}
            defaultValue={data.title}
            type={data.type}
            sortingType={sort && sort.type}
            sortingOrder={sort && sort.order}
            showSortingOrder={sort && sorting.length > 1}
            editableHeader={editableHeader}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
        />
    )
}

export default HeaderCell
